import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: 210,
    [theme.breakpoints.down('sm')]: {
      width: 350
    }
  }
}))

export default useStyles
